import { useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
import type { BuildPlan, BuildStep } from '../../types';

interface CompletionBannerProps {
  buildPlan: BuildPlan | null;
}

export function CompletionBanner({ buildPlan }: CompletionBannerProps) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const verifiedCount =
    buildPlan?.steps.filter((s: BuildStep) => s.status === 'verified').length ?? 0;

  return (
    <div className="border-b bg-green-50 dark:bg-green-950/20 px-4 py-2 flex items-center gap-2">
      <CheckCircle2 className="h-4 w-4 shrink-0 text-green-600 dark:text-green-400" />
      <span className="flex-1 text-xs text-green-800 dark:text-green-200">
        Build complete
        {buildPlan ? ` — ${verifiedCount} step${verifiedCount !== 1 ? 's' : ''} verified` : ''}.
        Refine with the prompt below.
      </span>
      <button
        onClick={() => setDismissed(true)}
        className="shrink-0 text-green-600 dark:text-green-400 hover:text-green-800 dark:hover:text-green-200"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
